import React from 'react'
import _ from 'lodash'

import checkPermission from '../../../../../../utilities/checkPermission'
import useAppFolderAndTabAction from '../../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useLoading from '../../../../../../control/loading/useLoading'
import useTranslate from '../../../../../../i18n/useTranslate'
import useWebService from '../../../../../../services/web/useWebService'
import useFolderAndTab from '../../../useFolderAndTab'
import useAppAlertMessageAction from '../../../../../../stores/appAlertMessage/appAlertMessageAction'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import { InitialRichTextEditorType } from '../../../../../../control/richTextEditor/richTextEditor'
import { memorandumTopic } from '../../../../../../constants/constants'
import { UploadFileObjCerType } from '../../generateCertificate/generateCertificateType'
import {
    ResultCertificateCloseProjectResponse,
    SynthesisReviewResultType,
} from '../../../../../../services/web/types/responseWebServiceTypes'
import { CertificateCloseProjectType } from '../../../../../../services/web/types/requestWebServiceTypes'
import { dateForAPI } from '../../../../../../utilities/date'
import { RoutePath } from '../../../../../../router/routesConfig'
import { useHistory } from 'react-router-dom'
import { DialogType } from '../../../../../../control/dialog/dialog'
import { ReportedCloseProjectType } from './reportedCloseProject'
import { FormRenderProps } from 'react-final-form'
import { OptType } from '../../memoMessageTerminateProject/memoMessageType'
import useLookupService from '../../../../../../services/lookup/useLookupService'
import * as REQServiceType from '../../../../../../services/web/types/requestWebServiceTypes'
import { validateModeAccordionError } from '../../../../../../utilities/validate'

const useCloseProject = (props: ReportedCloseProjectType) => {
    const { projectData, onSaveComplete, projectModeEdit = false } = props

    const callWebService = useWebService()
    const callLookup = useLookupService()
    const checkPermissionHook = checkPermission()
    const tabAndFolderHook = useFolderAndTab()
    const history = useHistory()
    const translate = useTranslate()
    const loadingHook = useLoading()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const appAlertMessageAction = useAppAlertMessageAction()
    const manageProjectStore = useManageProjectStore()

    const [initialValues, setInitialValues] = React.useState<any>({})
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const isShowUpdateDate = checkPermissionHook.chkShowUpdateDate(projectData)
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const formRef = React.useRef<FormRenderProps>()
    const editRef = React.useRef<any>()

    const [initialMemorandumFile, setInitialMemorandumFile] = React.useState<any>()
    const [initialMemoMessagePaper, setInitialMemoMessagePaper] = React.useState<{
        TH: InitialRichTextEditorType
        EN: InitialRichTextEditorType
    }>()
    const [initialSuggestionNotice, setInitialSuggestionNotice] = React.useState<InitialRichTextEditorType>()
    const [consideration, setConsideration] = React.useState<OptType[]>([])

    React.useEffect(() => {
        if (projectData) {
            createInitialData()
            getConsideration(projectData?.irb)
        }
    }, [
        projectData?.projectID ?? null,
        projectData?.submittedID ?? null,
        projectData?.considerInfo ?? null,
        translate.languageStore.currentLanguage,
    ])

    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }

    const getMemoMessage = async () => {
        const submittedID = manageProjectStore?.projectData?.submittedID ?? null
        if (submittedID) {
            const { result } = await callWebService.getCertificateCloseProject(submittedID)
            return result
        }
    }

    const getConsideration = async (irb: number) => {
        let res = await callLookup.getApproveStatusByCloseProject(irb)
        const formatData = res?.result?.map((itm) => {
            return {
                label:
                    translate.languageStore.currentLanguage === translate.languageKey.th
                        ? itm.approveStatusName_th
                        : itm.approveStatusName_en,
                value: `${itm.approveStatusId}`,
            }
        }) as []
        setConsideration(formatData)
    }

    const getSynthesisReviewData = async (submittedID: number) => {
        if (submittedID) {
            const { result } = await callWebService.getSynthesisReview(submittedID)
            return result
        }
    }

    /**
     * Default value form
     */
    const createInitialData = async () => {
        const result = await getMemoMessage()

        if (result) {
            const initialData = {
                memoMessageDate: result.memoMessageCommentDate ? new Date(result.memoMessageCommentDate) : new Date(),
                approveStatus:
                    result && result?.approveStatusInfo
                        ? {
                              label:
                                  translate.languageStore.currentLanguage === translate.languageKey.th
                                      ? result.approveStatusInfo.nameTH
                                      : result.approveStatusInfo.nameEN,
                              value: result?.approveStatusInfo.value.toString(),
                          }
                        : null,
            }

            let initialSugestionNotice
            if (projectModeEdit) {
                if (manageProjectStore?.projectData?.aroundSubmittedIDInfo.previousSubmittedID) {
                    const resultSynthesisReview = await getSynthesisReviewData(
                        manageProjectStore?.projectData?.aroundSubmittedIDInfo.previousSubmittedID,
                    )
                    /******* SuggestionNotice edit********/
                    initialSugestionNotice = createInitialSuggestionModeEdit(resultSynthesisReview)
                }
            } else {
                /******* SuggestionNotice ********/
                initialSugestionNotice = createInitialSuggestion(result)
            }

            /******* Paper ********/
            const initialMemoMessagePaper = createInitialPaper(result)
            //************ file *************/
            const initialMemorandumFile = createInitialFileMemorandum(result)

            /******set state *******/
            setInitialValues(initialData)
            setInitialMemorandumFile(initialMemorandumFile)
            setInitialMemoMessagePaper(initialMemoMessagePaper)
            setInitialSuggestionNotice(initialSugestionNotice)
        }
    }

    /**
     * SuggestionNotice
     */

    const createInitialSuggestion = (content: ResultCertificateCloseProjectResponse) => {
        const initialSugestionNotice = {
            contentHtml: content?.synthesisReviewRemark_html,
            contentText: content?.synthesisReviewRemark,
        }

        return initialSugestionNotice
    }

    const createInitialSuggestionModeEdit = (content?: SynthesisReviewResultType) => {
        const initialSugestionNotice = {
            contentHtml: content?.synthesisReviewRemarkInfo.synthesisReviewRemark_html ?? '',
            contentText: content?.synthesisReviewRemarkInfo.synthesisReviewRemark ?? '',
        }
        return initialSugestionNotice
    }

    /**
     * Paper
     */
    const createInitialPaper = (content: ResultCertificateCloseProjectResponse) => {
        const initialMemoMessagePaper = {
            TH: {
                contentHtml: content?.memoMessagePaper_th_html,
                contentText: content?.memoMessagePaper_th,
            },
            EN: {
                contentHtml: content?.memoMessagePaper_en_html,
                contentText: content?.memoMessagePaper_en,
            },
        }
        return initialMemoMessagePaper
    }

    /**
     * file
     */

    const createInitialFileMemorandum = (content: ResultCertificateCloseProjectResponse) => {
        const uploadFileMemoranduminit: Array<UploadFileObjCerType> = memorandumTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                },
            }
        })
        uploadFileMemoranduminit.forEach((itm: UploadFileObjCerType) => {
            if (itm.uploadFileObj.documentTopicID === 0) {
                let fileListTH = {
                    documentTopicID: 0,
                    fileToken: content?.memoMessagePaperInfo.name_th,
                    filename: content?.memoMessagePaperInfo.name_th,
                    fileID: content?.memoMessagePaperInfo.name_th,
                    path: content?.memoMessagePaperInfo.unSignPathInfo.path_th,
                }
                //@ts-ignore
                itm.uploadFileObj.fileList.push(fileListTH)
            } else if (itm.uploadFileObj.documentTopicID === 1) {
                let fileListEN = {
                    documentTopicID: 1,
                    fileToken: content?.memoMessagePaperInfo.name_en,
                    filename: content?.memoMessagePaperInfo.name_en,
                    fileID: content?.memoMessagePaperInfo.name_en,
                    path: content?.memoMessagePaperInfo.unSignPathInfo.path_en,
                }
                //@ts-ignore
                itm.uploadFileObj.fileList.push(fileListEN)
            }
        })
        return uploadFileMemoranduminit
    }

    const handleClickOpenFile = async (url: string) => {
        let xmlHttp = new XMLHttpRequest()

        xmlHttp.open('GET', url, true) // false for synchronous request
        xmlHttp.onreadystatechange = function () {
            // In local files, status is 0 upon success in Mozilla Firefox
            if (xmlHttp.readyState === XMLHttpRequest.DONE) {
                var status = xmlHttp.status
                if (status === 0 || (status >= 200 && status < 400)) {
                    // The request has been completed successfully
                    window.open(url)
                } else {
                    // Oh no! There has been an error with the request!
                    appAlertMessageAction.openAlertMessage({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        message: translate.get('MESSAGE.M011'),
                    })
                }
            }
        }
        xmlHttp.send()
    }

    /**
     *
     * process save
     */

    const getSaveServiceParameter = (isDraft: boolean) => {
        const value = formRef.current?.values
        const submittedID = manageProjectStore?.projectData?.submittedID ?? null
        let param: CertificateCloseProjectType = {
            submittedID: submittedID,
            memoMessagePaper_th:
                value?.memoMessagePaper_TH && value?.memoMessagePaper_TH.contentText
                    ? value?.memoMessagePaper_TH.contentText
                    : null,
            memoMessagePaper_en:
                value?.memoMessagePaper_EN && value?.memoMessagePaper_EN.contentText
                    ? value?.memoMessagePaper_EN.contentText
                    : null,
            memoMessagePaper_th_html:
                value?.memoMessagePaper_TH && value?.memoMessagePaper_TH.contentHtml
                    ? value?.memoMessagePaper_TH.contentHtml
                    : null,
            memoMessagePaper_en_html:
                value?.memoMessagePaper_EN && value?.memoMessagePaper_EN.contentHtml
                    ? value?.memoMessagePaper_EN.contentHtml
                    : null,
            memoMessageDate: value?.memoMessageDate ? dateForAPI(value?.memoMessageDate) ?? null : null,
            isDraft: isDraft,
        }
        return param
    }
    const processSaveData = async (
        param: CertificateCloseProjectType,
        changeTabOpt?: { idx: number; selectedInfo: any },
    ) => {
        dialogRef.current?.closeDialog()
        try {
            loadingHook.loadingOpen()

            const response = await callWebService.certificateCloseProject(param)

            if (changeTabOpt) {
                if (changeTabOpt.idx !== null && changeTabOpt.selectedInfo !== null) {
                    tabAndFolderHook.setTab(changeTabOpt.idx, changeTabOpt.selectedInfo)
                }
            } else {
                if (onSaveComplete) onSaveComplete(response.status, param.isDraft as boolean)
            }
        } catch (ex) {
            console.log('useDefineProject.ts => processSaveData : ', ex)
        } finally {
            loadingHook.loadingClose()
        }
    }

    const handleSubmitForm = (value: any) => {
        const isDraft: boolean = value?.submitType !== 'save'
        const param = getSaveServiceParameter(isDraft)
        if (isDraft) {
            //ถ้า save draft ไม่ต้องมี alert confirm
            processSaveData(param)
        } else {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
                type: 'alert-confirm',
                onClickConfirm: () => {
                    processSaveData(param)
                },
            })

            dialogRef.current?.openDialog()
        }
    }

    /**
     *
     * button back to search
     */
    const handleClickBackToSearch = () => {
        history.push(RoutePath.manageProject)
    }

    /**
     *
     * Dirty
     */

    const handleDirtyChange = (props: any) => {
        let isDirty: boolean = false
        const initialVal = {
            ...initialValues,
            memoMessagePaper_EN: {
                contentHtml: initialMemoMessagePaper?.EN.contentHtml ?? '',
                contentText: initialMemoMessagePaper?.EN.contentText ?? '',
            },
            memoMessagePaper_TH: {
                contentHtml: initialMemoMessagePaper?.TH.contentHtml ?? '',
                contentText: initialMemoMessagePaper?.TH.contentText ?? '',
            },
            memorandumFile: initialMemorandumFile,
            suggestionNotice: {
                contentHtml: initialSuggestionNotice?.contentHtml ?? '',
                contentText: initialSuggestionNotice?.contentText ?? '',
            },
        }
        let newFormValue = _.omit(props.values, ['submitType'])
        let initValue = _.omit(initialVal, ['submitType'])

        const isEqual = _.isEqual(initValue, newFormValue)

        if (!isViewMode) {
            if (isEqual) {
                isDirty = false
            } else {
                isDirty = true
            }
        }

        const paramsDirty = {
            tabDirty: isDirty,
            callbackDirty: isDirty ? callbackDirtyProcess : undefined,
        }

        appFolderAndTabAction.setDirty(paramsDirty)
    }
    const callbackDirtyProcess = (tabIndex: number, newTabSelected: any) => {
        const isDraft = true
        const param = getSaveServiceParameter(isDraft)
        processSaveData(param, {
            idx: tabIndex,
            selectedInfo: newTabSelected,
        })
    }

    const updateMemoMessage = async (param: REQServiceType.UpdateMemoMessageType) => {
        loadingHook.loadingOpen()
        const res = await callWebService.updateMemoMessagePaper(param)

        if (res.result.status === 200) {
            dialogRef.current?.openDialog()
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                type: 'alert-message',
                onAfterClose: () => {
                    setConfigDialog({})
                },
            })
        }
        loadingHook.loadingClose()
    }

    const handleSubmitUpdateMemo = (fieldNames: string[]) => {
        const isError = validateModeAccordionError(fieldNames, formRef.current)
        return new Promise(async (resolve, reject) => {
            if (isError) {
                formRef.current?.form.submit()
                reject('')
            } else {
                resolve('')
                const param: REQServiceType.UpdateMemoMessageType = {
                    submittedID: Number(projectData?.submittedID),
                    memoMessagePaperTH: formRef.current?.values.memoMessagePaper_TH.contentText,
                    memoMessagePaperEN: formRef.current?.values.memoMessagePaper_EN.contentText,
                    memoMessagePaperTHHTML: formRef.current?.values.memoMessagePaper_TH.contentHtml,
                    memoMessagePaperENHTML: formRef.current?.values.memoMessagePaper_EN.contentHtml,
                }

                updateMemoMessage(param)
            }
        })
    }

    const handleCancle = () => {
        const valueMessageTH: InitialRichTextEditorType = {
            contentHtml: editRef.current[`memoMessagePaper_TH`].contentHtml,
            contentText: editRef.current[`memoMessagePaper_TH`].contentText,
        }
        const valueMessageEN: InitialRichTextEditorType = {
            contentHtml: editRef.current[`memoMessagePaper_EN`].contentHtml,
            contentText: editRef.current[`memoMessagePaper_EN`].contentText,
        }
        setInitialMemoMessagePaper((prev) => ({
            TH: {
                ...prev?.TH,
                ...valueMessageTH,
            },
            EN: {
                ...prev?.EN,
                ...valueMessageEN,
            },
        }))
    }

    const onClickEdit = () => {
        editRef.current = formRef.current?.form.getState().values
    }
    return {
        formRef,
        isViewMode,
        configDialog,
        consideration,
        initialValues,
        isShowUpdateDate,
        initialMemorandumFile,
        initialMemoMessagePaper,
        initialSuggestionNotice,

        onRefDialog,
        onDirtyChange: handleDirtyChange,
        onSubmitForm: handleSubmitForm,
        onClickBackToSearch: handleClickBackToSearch,
        onClickOpenFile: handleClickOpenFile,
        handleSubmitUpdateMemo,
        handleCancle,
        onClickEdit,
    }
}
export default useCloseProject
